"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _reactTabs = require("react-tabs");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _FlexibleComponents = _interopRequireDefault(require("../FlexibleComponents"));
var _ComponentWrapper = _interopRequireDefault(require("../../helpers/ComponentWrapper"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Component = exports["default"] = /*#__PURE__*/function (_React$PureComponent) {
  function Component() {
    (0, _classCallCheck2["default"])(this, Component);
    return _callSuper(this, Component, arguments);
  }
  (0, _inherits2["default"])(Component, _React$PureComponent);
  return (0, _createClass2["default"])(Component, [{
    key: "render",
    value: function render() {
      var tabs = this.props.tabs;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactTabs.Tabs, {
        selectedTabClassName: "active"
      }, /*#__PURE__*/_react["default"].createElement(_ComponentWrapper["default"], null, /*#__PURE__*/_react["default"].createElement(_reactTabs.TabList, {
        className: "row mt20 mb20",
        style: {
          maxWidth: '600px',
          margin: '20px auto',
          marginBottom: '40px',
          paddingLeft: 0
        }
      }, tabs.map(function (tab) {
        return /*#__PURE__*/_react["default"].createElement(_reactTabs.Tab, {
          key: tab.title,
          className: "btn btn--filter col"
        }, tab.title);
      }))), tabs.map(function (tab) {
        return /*#__PURE__*/_react["default"].createElement(_reactTabs.TabPanel, {
          key: tab.title,
          className: "l-tabs__panel"
        }, /*#__PURE__*/_react["default"].createElement(_FlexibleComponents["default"], {
          components: tab.components
        }));
      })));
    }
  }]);
}(_react["default"].PureComponent);
(0, _defineProperty2["default"])(Component, "propTypes", {
  tabs: _propTypes["default"].array.isRequired
});